import RecipientService from '@/services/RecipientService'
import countriesConstants from '@/constants/CountriesConstants'

export default {
  actions: {
    async fetchRecipients (ctx) {
      const recipients = await RecipientService.methods.getRecipients()
      ctx.commit('updateRecipients', recipients.GetRecipientsResponse.RecipientItems.RecipientItem)
    },
    async fetchRecipient (ctx, recipientId = '') {
      const recipient = await RecipientService.methods.getRecipient(recipientId)
      ctx.commit('updateRecipient', recipient.GetRecipientsResponse.RecipientItems.RecipientItem)
    },
    async fetchRecipientFields (ctx, remittanceOptionsId) {
      const recipientFields = await RecipientService.methods.getRecipientFields(remittanceOptionsId)
      ctx.commit('updateRecipientFields', [recipientFields.GetRecipientFieldsResponse.FieldData.DetailedFieldData, remittanceOptionsId])
    },
    async fetchCountryPhoneCode (ctx, country) {
      ctx.commit('updateCountryPhoneCode', countriesConstants.countriesPhoneCode[country])
    }
  },
  mutations: {
    updateRecipient (state, recipient) {
      const parseRecipient = () => {
        if (recipient) {
          (Object.values(recipient).map((e, key) => {
            const objectKey = Object.keys(recipient)[key].charAt(0).toLowerCase() + Object.keys(recipient)[key].slice(1)
            if (objectKey === 'customProperties') {
              recipient[objectKey] = Array.isArray(recipient[Object.keys(recipient)[key]].NameValuePair)
                ? recipient[Object.keys(recipient)[key]].NameValuePair.map((elemChild, keyChild) => {
                  return {
                    key: elemChild.Name._text,
                    value: elemChild.Value._text
                  }
                })
                : recipient[Object.keys(recipient)[key]].NameValuePair = [
                  {
                    key: recipient[Object.keys(recipient)[key]].NameValuePair && recipient[Object.keys(recipient)[key]].NameValuePair.Name._text,
                    value: recipient[Object.keys(recipient)[key]].NameValuePair && recipient[Object.keys(recipient)[key]].NameValuePair.Value._text
                  }
                ]
            } else {
              recipient[objectKey] = e._text
            }
          }))
          return recipient
        } else {
          return {}
        }
      }
      state.recipient = parseRecipient()
    },
    updateRecipients (state, recipients) {
      const mapper = recipient => {
        return {
          city: recipient.City._text,
          country: recipient.Country._text,
          customProperties: Object.keys(recipient.CustomProperties).length > 0 && recipient.CustomProperties.NameValuePair
            ? Array.isArray(recipient.CustomProperties.NameValuePair)
              ? recipient.CustomProperties.NameValuePair.map(elem => {
                return {
                  name: elem.Name._text,
                  value: elem.Value._text
                }
              })
              : {
                name: recipient.CustomProperties.NameValuePair.Name ? recipient.CustomProperties.NameValuePair.Name._text : null,
                value: recipient.CustomProperties.NameValuePair.Value ? recipient.CustomProperties.NameValuePair.Value._text : null
              }
            : [],
          emailAddress: recipient.EmailAddress._text,
          firstName: recipient.FirstName._text,
          id: recipient.Id._text,
          lastName: recipient.LastName._text,
          middleName: recipient.MiddleName._text,
          mobileNumber: recipient.MobileNumber._text,
          phoneNumber: recipient.PhoneNumber._text,
          postalCode: recipient.PostalCode._text,
          remitDisabled: recipient.RemitDisabled._text,
          remittanceCurrency: recipient.RemittanceCurrency._text,
          remittanceGatewayId: recipient.RemittanceGatewayId._text,
          securityCode: recipient.SecurityCode._text,
          state: recipient.State._text,
          streetAddress1: recipient.StreetAddress1._text,
          streetAddress2: recipient.StreetAddress2._text,
          transactionPurposeId: recipient.TransactionPurposeId._text
        }
      }
      let _recipients = Array.isArray(recipients) ? recipients.map(mapper) : recipients ? [recipients].map(mapper) : []
      state.recipients = _recipients.filter(rec => this.state.currencies.avilableRemittanceOptionsIds.includes(rec.remittanceGatewayId))
    },
    updateRecipientFields (state, [recipientFields, remittanceOptionsId]) {
      state.recipientFields = recipientFields
        .map(field => {
          return {
            defaultValue: field.DefaultValue._text,
            description: field.Description._text,
            isPersonalField: field.IsPersonalField._text,
            maxLength: field.MaxLength._text,
            minLength: field.MinLength._text,
            name: field.Name._text,
            optional: field.Optional._text,
            order: field.Order._text,
            // possibleValues: field.PossibleValues,
            possibleValues: Object.keys(field.PossibleValues).length > 0 ? field.PossibleValues.ValueDescription.map(val => {
              return {
                description: val.Description._text,
                value: val.Value._text
              }
            }) : field.PossibleValues._text,
            requiresConfirmation: field.RequiresConfirmation._text,
            row: field.Row._text,
            useRegEx: field.UseRegEx._text
          }
        })
      if (!state.recipientFieldsList.find(rf => +rf.remittanceOptionsId === +remittanceOptionsId)) {
        state.recipientFieldsList.push({
          recipientFields: state.recipientFields,
          recipientOnlyPersonalFields: state.recipientFields.filter(field => field.isPersonalField !== 'false'),
          recipientNotPersonalFields: state.recipientFields.filter(field => field.isPersonalField === 'false'),
          remittanceOptionsId })
      }
    },
    updateCountryPhoneCode (state, countryPhoneCode) {
      state.countryPhoneCode = countryPhoneCode
    }
  },
  getters: {
    getRecipient (state) {
      return state.recipient
    },
    getRecipients (state) {
      return state.recipients
    },
    getRecipientFields (state) {
      return state.recipientFields
    },
    getRecipientFieldsList (state) {
      return state.recipientFieldsList
    },
    getOnlyPersonalFields (state) {
      return state.recipientFields.filter(field => field.isPersonalField !== 'false')
    },
    getNotPersonalFields (state) {
      return state.recipientFields.filter(field => field.isPersonalField === 'false')
    },
    getCountryPhoneCode (state) {
      return state.countryPhoneCode
    }
  },
  state: {
    recipient: null,
    recipients: [],
    recipientFields: null,
    recipientFieldsList: [],
    countryPhoneCode: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/recipients.js